module.exports = __webpack_public_path__ + "img/text2.a26fd4a1.svg";